import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 10",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "nonzero",
			d: "M4.131 7.89L1.05 4.78 0 5.831 4.131 10 13 1.051 11.958 0z"
		})
	})
});
export default SvgCheckMark;
